<ng-container [ngSwitch]="true">
  <ng-container *ngSwitchCase="type === 'image' && imageSrc && true">
    <img #image [src]="imageSrc" [ngStyle]="imageStyles" (error)="imageError.emit($event)"
  /></ng-container>

  <ng-container *ngSwitchCase="type === 'image-with-container' && imageSrc && true">
    <div
      class="image-container"
      [ngStyle]="imageStyles"
      [style.background-image]="'url(' + imageSrc + ')'"
    ></div
  ></ng-container>

  <ng-container *ngSwitchCase="type === 'initials' && nameInitials && true">
    <div
      #avatarPlaceholder
      class="avatar-placeholder"
      [class.is-candidate]="context === 'candidate'"
      [class.is-admin]="context === 'admin'"
      [class.is-other]="context === 'other'"
      [class.font-size-backend-style]="fontSize === 'small'"
      [class.colorized]="isColorized"
    >
      <div class="initials">{{ nameInitials }}</div>
    </div></ng-container
  >

  <ng-container *ngSwitchCase="type === 'icon' && iconName && true">
    <div
      class="avatar-icon"
      [class.light]="isIconLight"
      [class.is-candidate]="context === 'candidate'"
      [class.is-other]="context === 'other'"
      [class.transparent]="isIconBgTransparent"
    >
      <rt-icon [name]="iconName" [size]="customIconSize || iconSize"></rt-icon>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="type === 'custom' && avatarTpl && true">
    <ng-container *ngTemplateOutlet="avatarTpl!"></ng-container>
  </ng-container>
</ng-container>

<div *ngIf="isOnline" class="online-indicator"></div>

<div *ngIf="hasUnreadNotifications" class="has-notifications">
  <ng-container *ngTemplateOutlet="tooltipTplRef"></ng-container>
</div>
